import { IFoDotDangKyAn } from "../models/response/thuc-don/IFoDotDangKyAn";
import { apiClient } from "./apiClient";

export const FO_DOT_DANG_KY_AN_API_END_POINT = "food/dot-dang-ky-an";

export const foDotDangKyAnApi = {
    select_all: () => apiClient.get(FO_DOT_DANG_KY_AN_API_END_POINT),
    select_by_id: (id: number) => apiClient.get(`${FO_DOT_DANG_KY_AN_API_END_POINT}/${id}`),
    select_by_coso_namhoc: (dm_coso_id: number, nam_hoc: string) => apiClient.get(`${FO_DOT_DANG_KY_AN_API_END_POINT}/co-so/${dm_coso_id}/nam-hoc/${nam_hoc}`),
    insert: (data: IFoDotDangKyAn) => apiClient.post(FO_DOT_DANG_KY_AN_API_END_POINT, data),
    update: (data: IFoDotDangKyAn) => apiClient.put(FO_DOT_DANG_KY_AN_API_END_POINT, data),
    delete: (id: number) => apiClient.delete(`${FO_DOT_DANG_KY_AN_API_END_POINT}/${id}`),
    saveChanges: (data: any) => apiClient.post(`${FO_DOT_DANG_KY_AN_API_END_POINT}/savechanges`, data)
};
